import React, { useEffect } from 'react';
import { Form } from 'formik';
import { Badge, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';

import { LOGISTIC_TYPE } from '../../../../../../../../constants';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import OrderLogistics from './OrderLogistics';
import CommissionSection from './CommissionSection';
import ChargesSection from './ChargesSection';
import AddressSection from './AddressSection';
import PaymentSection from './PaymentSection';
import Uploadpipo from './Uploadpipo';

const DEFAULT_SECTIONS = [
  'summary',
  'address',
  'charges',
  'commission',
  'payment',
  'logistics',
  'pipo',
];

const EditOrderForm = (props) => {
  const {
    values,
    handleAddress,
    isChargeFormDisabled,
    isLogisticSelf: propIsLogisticSelf,
    handleShowProof,
    handleChange,
    handleCharges,
    setFieldValue,
    orderData,
    validateForm,
    submitForm,
    refetchOrderData,
    onOrderUpdated,
    sections = DEFAULT_SECTIONS,
    validateTimestamp,
  } = props;
  const visibleSections = new Set(sections);
  const grandTotal = orderData?.order?.total ?? values?.total ?? 0;

  const logisticSetting = [
    values?.isLogisticSelf,
    propIsLogisticSelf,
    orderData?.order?.isLogisticSelf,
  ].find((value) => value !== undefined && value !== null && value !== '');
  const isLogisticSelf = logisticSetting === true || logisticSetting === 'true';
  const hasLogisticSelection =
    isLogisticSelf || logisticSetting === false || logisticSetting === 'false';
  const chargesDisabled =
    isChargeFormDisabled || !hasLogisticSelection || isLogisticSelf;

  useEffect(() => {
    if (validateTimestamp) {
      submitForm();
      setTimeout(() => {
        const errorElement = document.querySelector('.is-invalid');
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }, [validateTimestamp, submitForm]);

  return (
    <Form className="edit-order-form">
      {visibleSections.has('summary') && (
        <CardWithTitle title="Order Details">
          <Row>
            <Col>
              <h5 className="fw-medium f-12">Grade:</h5>
              <h6>
                <Badge color="primary" className="font-weight-600 font-12">
                  {values?.grade?.name}
                </Badge>
              </h6>
            </Col>
            <Col>
              <h5 className="fw-medium f-12">Order Rate:</h5>
              <h6 className="font-weight-600 font-12 padding-7-5">
                {values?.rate?.toLocaleString('en-IN')}/KG
              </h6>
            </Col>
            <Col>
              <h5 className="fw-medium f-12">Order QTY:</h5>
              <h6 className="font-weight-600 font-12 padding-7-5">
                {values?.quantity?.toLocaleString('en-IN')}{' '}
                {values?.quantityUnit?.label}
              </h6>
            </Col>
            <Col>
              <h5 className="fw-medium f-12">Pending QTY:</h5>
              <h6 className="font-weight-600 font-12 padding-7-5">
                {values?.pendingQuantity?.toLocaleString('en-IN')}{' '}
                {values?.quantityUnit?.label}
              </h6>
            </Col>
            <Col>
              <h5 className="fw-medium f-12">Logistic By:</h5>
              <h6 className="font-weight-600 font-12 padding-7-5">
                {values?.isLogisticSelf
                  ? LOGISTIC_TYPE.SELF
                  : LOGISTIC_TYPE.POLYSTOX}
              </h6>
            </Col>
          </Row>
        </CardWithTitle>
      )}

      {visibleSections.has('address') && (
        <AddressSection
          values={values}
          setFieldValue={setFieldValue}
          handleAddress={handleAddress}
        />
      )}
      {visibleSections.has('charges') && !isLogisticSelf && (
        <ChargesSection
          values={values}
          isChargeFormDisabled={chargesDisabled}
          handleCharges={handleCharges}
          refetchOrderData={refetchOrderData}
          onOrderUpdated={onOrderUpdated}
        />
      )}
      {visibleSections.has('commission') && (
        <CommissionSection
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
        />
      )}
      {visibleSections.has('payment') && (
        <PaymentSection
          values={values}
          handleShowProof={handleShowProof}
          setFieldValue={setFieldValue}
          grandTotal={grandTotal}
          refetchOrderData={refetchOrderData}
          onOrderUpdated={onOrderUpdated}
        />
      )}
      {visibleSections.has('logistics') && (
        <OrderLogistics
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          refetchOrderData={refetchOrderData}
          orderData={orderData}
          validateForm={validateForm}
          submitForm={submitForm}
          onOrderUpdated={onOrderUpdated}
        />
      )}
      {visibleSections.has('pipo') && (
        <Uploadpipo values={values} setFieldValue={setFieldValue} />
      )}
    </Form>
  );
};

export default EditOrderForm;
